module.exports = __webpack_public_path__ + "media/images/deployed_to_canvas_icon-7a0d4786d400f0ef45d52dede21c6051.png";